import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import { Agency } from '@app/models';
import { updateAgencyDisplaySettingsMutation } from '@app/pcs/data/agency.mutations';
import { reloadAgenciesQuery } from '@app/pcs/data/agency.queries';

@Injectable()
export class AgencyDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  updateAgencyDisplaySettings(agency: Agency) {
    return this.graphqlService.mutation(updateAgencyDisplaySettingsMutation, {
      agency
    }, hideLoader());
  }

  reloadAgencies() {
    return this.graphqlService.query(reloadAgenciesQuery);
  }
}
